import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { Component } from '@angular/core';
import { ChartModule } from 'primeng/chart';
import { FluidModule } from 'primeng/fluid';
import { debounceTime, Subscription } from 'rxjs';
// import { LayoutService } from '../../layout/service/layout.service';
import { LayoutService } from '../layout/service/layout.service';

@Component({
    selector: 'app-pie-chart',
    imports: [CommonModule, ChartModule, FluidModule],
    templateUrl: './pie-chart.component.html',
    styleUrl: './pie-chart.component.scss'
})
export class PieChartComponent {
    lineData: any;

    barData: any;

    pieData: any;

    polarData: any;

    radarData: any;

    lineOptions: any;

    barOptions: any;

    pieOptions: any;

    polarOptions: any;

    radarOptions: any;

    subscription: Subscription;

    bubbleData: any;
    bubbleOptions: any;

    scatterData: any;
    scatterOptions: any;

    horizontalBarData: any;
    horizontalBarOptions: any;

    stackedBarData: any;
    stackedBarOptions: any;

    mixedData: any;
    mixedOptions: any;

    areaData: any;
    areaOptions: any;

    doughnutData: any;
    doughnutOptions: any;

    salesPersons: string[] = ['Omkar', 'Somnath', 'Rasika', 'Vinay', 'Mahesh', 'Nikita'];
    salesData: number[] = [220, 190, 180, 110, 140, 170];
    groupedBarData: { labels: string[]; datasets: { label: string; data: number[]; backgroundColor: string }[] } | undefined;

    constructor(private layoutService: LayoutService) {
        this.subscription = this.layoutService.configUpdate$.pipe(debounceTime(25)).subscribe(() => {
            this.initCharts();
        });
    }

    ngOnInit() {
        this.initCharts();
    }

    initCharts() {
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        // Salespersons and random sales data
        const salesPersons = ['Vinay', 'Somnath','Omkar', 'Rasika',  'Mahesh', 'Nikita'];
        const salesData = [180, 220, 230, 200, 110, 140];

        // Bubble Chart (x: index, y: sales, r: random size)
        this.bubbleData = {
            datasets: [
                {
                    label: 'Sales',
                    data: salesData.map((y, i) => ({ x: i + 1, y, r: Math.floor(Math.random() * 10) + 5 })),
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500')
                }
            ]
        };
        this.bubbleOptions = {
            plugins: { legend: { labels: { color: textColor } } },
            scales: {
                x: { title: { display: true, text: 'Salesperson', color: textColor }, ticks: { color: textColorSecondary } },
                y: { title: { display: true, text: 'Sales', color: textColor }, ticks: { color: textColorSecondary } }
            }
        };

        // Scatter Chart (x: index, y: sales)
        this.scatterData = {
            datasets: [
                {
                    label: 'Sales',
                    data: salesData.map((y, i) => ({ x: i + 1, y })),
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500')
                }
            ]
        };
        this.scatterOptions = {
            plugins: { legend: { labels: { color: textColor } } },
            scales: {
                x: { title: { display: true, text: 'Salesperson', color: textColor }, ticks: { color: textColorSecondary } },
                y: { title: { display: true, text: 'Sales', color: textColor }, ticks: { color: textColorSecondary } }
            }
        };

        // Horizontal Bar Chart
        this.horizontalBarData = {
            labels: salesPersons,
            datasets: [
                {
                    label: 'Sales',
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
                    borderColor: documentStyle.getPropertyValue('--p-primary-500'),
                    data: salesData
                }
            ]
        };
        this.horizontalBarOptions = {
            indexAxis: 'y',
            plugins: { legend: { labels: { color: textColor } } },
            scales: {
                x: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder } },
                y: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder } }
            }
        };

        // Stacked Bar Chart (simulate two products)
        this.stackedBarData = {
            labels: salesPersons,
            datasets: [
                {
                    label: 'Product A',
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
                    data: salesData.map((v) => Math.floor(v * 0.6))
                },
                {
                    label: 'Product B',
                    backgroundColor: documentStyle.getPropertyValue('--p-orange-500'),
                    data: salesData.map((v) => Math.floor(v * 0.4))
                }
            ]
        };
        this.stackedBarOptions = {
            plugins: { legend: { labels: { color: textColor } } },
            responsive: true,
            scales: {
                x: { stacked: true, ticks: { color: textColorSecondary }, grid: { color: surfaceBorder } },
                y: { stacked: true, ticks: { color: textColorSecondary }, grid: { color: surfaceBorder } }
            }
        };

        // Mixed Chart (Bar + Line)
        this.mixedData = {
            labels: salesPersons,
            datasets: [
                {
                    type: 'bar',
                    label: 'Sales',
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
                    data: salesData
                },
                {
                    type: 'line',
                    label: 'Trend',
                    borderColor: documentStyle.getPropertyValue('--p-orange-500'),
                    borderWidth: 2,
                    fill: false,
                    data: salesData
                }
            ]
        };
        this.mixedOptions = {
            plugins: { legend: { labels: { color: textColor } } },
            scales: {
                x: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder } },
                y: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder } }
            }
        };

        // Area Chart (Line with fill)
        this.areaData = {
            labels: salesPersons,
            datasets: [
                {
                    label: 'Sales',
                    data: salesData,
                    fill: true,
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-200'),
                    borderColor: documentStyle.getPropertyValue('--p-primary-500'),
                    tension: 0.4
                }
            ]
        };
        this.areaOptions = {
            plugins: { legend: { labels: { color: textColor } } },
            scales: {
                x: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder } },
                y: { ticks: { color: textColorSecondary }, grid: { color: surfaceBorder } }
            }
        };

        // Bar Chart
        this.barData = {
            labels: salesPersons,
            datasets: [
                {
                    label: 'Sales',
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
                    borderColor: documentStyle.getPropertyValue('--p-primary-500'),
                    data: salesData
                }
            ]
        };

        this.barOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.8,
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: textColorSecondary,
                        font: { weight: 500 }
                    },
                    grid: { display: false, drawBorder: false }
                },
                y: {
                    beginAtZero: true, // <-- Ensure Y-axis starts at zero
                    ticks: { color: textColorSecondary },
                    grid: { color: surfaceBorder, drawBorder: false }
                }
            }
        };

        // Pie Chart
        this.pieData = {
            labels: salesPersons,
            datasets: [
                {
                    data: salesData,
                    backgroundColor: [
                        documentStyle.getPropertyValue('--p-indigo-500'),
                        documentStyle.getPropertyValue('--p-purple-500'),
                        documentStyle.getPropertyValue('--p-teal-500'),
                        documentStyle.getPropertyValue('--p-orange-500'),
                        documentStyle.getPropertyValue('--p-cyan-500'),
                        documentStyle.getPropertyValue('--p-pink-500')
                    ],
                    hoverBackgroundColor: [
                        documentStyle.getPropertyValue('--p-indigo-400'),
                        documentStyle.getPropertyValue('--p-purple-400'),
                        documentStyle.getPropertyValue('--p-teal-400'),
                        documentStyle.getPropertyValue('--p-orange-400'),
                        documentStyle.getPropertyValue('--p-cyan-400'),
                        documentStyle.getPropertyValue('--p-pink-400')
                    ]
                }
            ]
        };

        this.pieOptions = {
            plugins: {
                legend: {
                    labels: {
                        usePointStyle: true,
                        color: textColor
                    }
                }
            }
        };

        // Doughnut Chart
        const totalSales = salesData.reduce((a, b) => a + b, 0);
        this.doughnutData = {
            labels: salesPersons,
            datasets: [
                {
                    data: salesData,
                    backgroundColor: [
                        documentStyle.getPropertyValue('--p-indigo-500'),
                        documentStyle.getPropertyValue('--p-purple-500'),
                        documentStyle.getPropertyValue('--p-teal-500'),
                        documentStyle.getPropertyValue('--p-orange-500'),
                        documentStyle.getPropertyValue('--p-cyan-500'),
                        documentStyle.getPropertyValue('--p-pink-500')
                    ]
                }
            ]
        };
        this.doughnutOptions = {
            plugins: {
                legend: {
                    labels: {
                        color: textColor
                    }
                },
                tooltip: {
                    callbacks: {
                        label: function (context: any) {
                            const value = context.raw;
                            const percent = ((value / totalSales) * 100).toFixed(1);
                            return `${context.label}: ${value} (${percent}%)`;
                        }
                    }
                }
            }
        };

        // Line Chart
        this.lineData = {
            labels: salesPersons,
            datasets: [
                {
                    label: 'Sales',
                    data: salesData,
                    fill: false,
                    backgroundColor: documentStyle.getPropertyValue('--p-primary-500'),
                    borderColor: documentStyle.getPropertyValue('--p-primary-500'),
                    tension: 0.4
                }
            ]
        };

        this.lineOptions = this.barOptions; // Use same style as bar

        // Polar Area Chart
        this.polarData = {
            datasets: [
                {
                    data: salesData,
                    backgroundColor: [
                        documentStyle.getPropertyValue('--p-indigo-500'),
                        documentStyle.getPropertyValue('--p-purple-500'),
                        documentStyle.getPropertyValue('--p-teal-500'),
                        documentStyle.getPropertyValue('--p-orange-500'),
                        documentStyle.getPropertyValue('--p-cyan-500'),
                        documentStyle.getPropertyValue('--p-pink-500')
                    ],
                    label: 'Sales'
                }
            ],
            labels: salesPersons
        };

        this.polarOptions = {
            plugins: {
                legend: {
                    labels: { color: textColor }
                }
            },
            scales: {
                r: {
                    grid: { color: surfaceBorder },
                    ticks: { display: false, color: textColorSecondary }
                }
            }
        };

        // Radar Chart
        this.radarData = {
            labels: salesPersons,
            datasets: [
                {
                    label: 'Sales',
                    borderColor: documentStyle.getPropertyValue('--p-indigo-400'),
                    pointBackgroundColor: documentStyle.getPropertyValue('--p-indigo-400'),
                    pointBorderColor: documentStyle.getPropertyValue('--p-indigo-400'),
                    pointHoverBackgroundColor: textColor,
                    pointHoverBorderColor: documentStyle.getPropertyValue('--p-indigo-400'),
                    backgroundColor: documentStyle.getPropertyValue('--p-indigo-200'),
                    data: salesData
                }
            ]
        };

        this.radarOptions = {
            plugins: {
                legend: {
                    labels: { color: textColor }
                }
            },
            scales: {
                r: {
                    pointLabels: { color: textColor },
                    grid: { color: surfaceBorder }
                }
            }
        };

        const months = ['Apr', 'May', 'Jun'];
        const salesOmkar = [100, 120, 140];
        const salesSomnath = [90, 110, 130];
        const salesRasika = [80, 140, 120];
        const salesVinay = [70, 90, 110];
        const salesMahesh = [60, 80, 100];
        const salesNikita = [110, 130, 150];

        this.groupedBarData = {
            labels: months,
            datasets: [
                { label: 'Vinay', data: salesVinay, backgroundColor: '#AB47BC' },
                { label: 'Somnath', data: salesSomnath, backgroundColor: '#66BB6A' },
                { label: 'Omkar', data: salesOmkar, backgroundColor: '#42A5F5' },
                { label: 'Rasika', data: salesRasika, backgroundColor: '#FFA726' },

                { label: 'Mahesh', data: salesMahesh, backgroundColor: '#26C6DA' },
                { label: 'Nikita', data: salesNikita, backgroundColor: '#FF7043' }
            ]
        };
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
